import { ProductNotFound } from './products.selectors';
import { FilterObject } from 'src/app/dataLayer/ProductsModels/Helpers/FilterObject';
import { CartItemInterface, ProductAttributesInterface, RelatedProductInteface, SingleProductModel, product_details_resolver_interface, specifications_optionsModels } from './../../../dataLayer/ProductsModels/Entities/product.model';
import { Action } from "@ngrx/store";
import { SingleProductPrice } from "src/app/dataLayer/ProductsModels/Entities/product.model";
import { ProductListModel } from "src/app/dataLayer/ProductsModels/Entities/ProductList";
import * as types from "./constants/products.constant";
import { AttributesModel } from 'src/app/dataLayer/AttributesModel/AttributesMode';
import { ProductListViewState } from 'src/app/dataLayer/ProductsModels/Entities/product.state';
import { CheckVoucherInteface } from '../interfaces/IProductDetails';



// product details

export class GetSingleProduct implements Action
{

   readonly type: string = types.GetSingleProduct;
      constructor( public data: product_details_resolver_interface ){}

}


export class SingleProductLoaded implements Action
{

   readonly type: string = types.SingleProductLoadedType;
   constructor( public data: SingleProductModel ){}

}


export class ClearSingleProductAction implements Action
{

   readonly type: string = types.ClearSingleProduct;
   constructor(){}

}




export class UPDATE_ACTIVE_PRODUCT_ATTRIBUTES_ACTION implements Action
{
   readonly type: string = types.UpdateActiveProductAttribute;
   constructor( public data: ProductAttributesInterface[] ){}

}


export class UPDATE_ACTIVE_PRODUCT_PRICE_ACTION implements Action
{
   readonly type: string = types.UpdateActiveProductPrice;
   constructor( public data: number ){}

}

export class UPDATE_ACTIVE_PRODUCT_AMOUNT_ACTION implements Action
{
   readonly type: string = types.UPDATE_ACTIVE_PRODUCT_AMOUNT;
   constructor( public data: number | null ){}
}


// ProductList

export class GetProductList implements Action
{

   readonly type: string = types.GetProductList;
   constructor( public data: number ){}

}


export class ProductListLoaded implements Action
{

   readonly type: string = types.ProductListLoaded;
   constructor( public data: ProductListModel ){}

}



export class GetAttributesListByCat implements Action
{

   readonly type: string = types.GetAttribtuesListByCat;
   constructor( public data: number ){}

}
export class GetAttributesListBySubCat implements Action
{

   readonly type: string = types.GetAttribtuesListBySubCat;
   constructor( public data: number ){}

}


export class AttributesLoaded implements Action
{

   readonly type: string = types.GetAttribtuesListLoaded;
   constructor( public data: ProductListViewState ){}

}



export class GetBrandsList implements Action
{

   readonly type: string = types.GetBrandsList;
   constructor( public SubCat: number ){}

}

export class GetBrandsListForCat implements Action
{

   readonly type: string = types.GetBrandsListForCat;
   constructor( public SubCat: number ){}

}

export class GetBrandsListLoaded implements Action
{

   readonly type: string = types.BrandsLoaded;
   constructor( public data: FilterObject ){}

}

export class GetFilterList implements Action
{

   readonly type: string = types.GetFilterList;
   constructor( public data: FilterObject ){}

}


export class FilterLoaded implements Action
{

   readonly type: string = types.FilterLoaded;
   constructor( public data: FilterObject ){}

}


export class ResetStatus implements Action
{

   readonly type: string = types.ResetStatus;
   constructor(  ){}

}



export class GetProductListPagingAction implements Action
{

   readonly type: string = types.GetProductListPaging;
   constructor( public data: number,public page:string, public orderBy: string ){}

}


export class GetProductListPagingLoadedAction implements Action
{

   readonly type: string = types.GetProductListPagingLoaded;
   constructor( public data: ProductListModel ){}

}


export class GetProductNotFoundAction implements Action
{

   readonly type: string = types.ProductListNotFound;
   constructor( public data: boolean ){}

}


export class SortProducts implements Action
{

   readonly type: string = types.SortProducts;
   constructor( public data: ProductListViewState ){}

}


export class check_user_favourite_action implements Action
{

   readonly type: string = types.CheckUserFavourite;

   constructor(){}

}


export class set_user_favourite_action implements Action
{

   readonly type: string = types.SetUserFavourite;

   constructor(public data: boolean){}

}


export class set_user_favourite_id_action implements Action
{

   readonly type: string = types.SetUserFavouriteId;

   constructor(public data: number){}

}



export class SET_VOUCHER_ACTION implements Action
{

   readonly type: string = types.set_voucher;

   constructor(public data: string){}

}

export class set_voucher_data_action implements Action
{

   readonly type: string = types.set_voucher_data;

   constructor(public data: string){}

}


export class SET_VOUCHER_PERCENTAGE_ACTION implements Action
{

   readonly type: string = types.set_voucher_percentage;

   constructor(public data: number){}

}

export class SET_CART_TOTAL_WITH_VOUCHER_ACTION implements Action
{

   readonly type: string = types.set_cart_total_with_voucher;

   constructor(public data: number){}

}

export class CHECK_VOUCHER_ACTION implements Action
{

   readonly type: string = types.CHECK_VOUCHER;

   constructor(public data: CheckVoucherInteface){}

}

export class SET_CHECKOUT_NOTE_ACTION implements Action
{
   readonly type: string = types.SET_CHECKOUT_NOTE;
   constructor(public data: string){}
}


export class reserve_item_action implements Action
{
   readonly type: string = types.reserve_item;
   constructor(public data: any){}
}

export type ActionsUnion = FilterLoaded | GetFilterList | GetProductList | ProductListLoaded  ;
